module.exports = __webpack_public_path__ + "static/Vazir-Medium-e9eb4c1ce35c4173a336b72bb2af053c.woff2";